import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import Landing from "@/pages/Landing";
import StoryPage from "@/pages/StoryPage";
import "@/App.css";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80, duration: 1.4 });
          else el.scrollIntoView();
        }, 180);
        return;
      }
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

function App() {
  useLenis();

  return (
    <BrowserRouter>
      <ScrollManager />
      <div className="min-h-screen bg-sand" data-testid="app-root">
        <Nav />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/our-story" element={<StoryPage />} />
        </Routes>
        <Footer />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0d1821",
              color: "#f9f7f2",
              border: "1px solid rgba(249,247,242,0.18)",
              borderRadius: "2px",
              fontFamily: '"Plus Jakarta Sans", sans-serif',
            },
          }}
        />
      </div>
    </BrowserRouter>
  );
}

export default App;
